<template>
  <div class="comparison-skill-page">
    <div class="skill-name">简历分析</div>
    <div class="box-content">
      <div class="skill-content">
        <div class="content-item">
          <p class="content-title">对方的简历分析评分</p>
          <span>{{she.cv_analysis.cv_score}}</span>
          <div class="point-list">
            <div v-for="(item,index) in she.cv_analysis.highlights" :key="index">
              <div v-if="typeof(item) === 'string'">
                <div class="list-item">
                  <p>亮点</p>
                  <span>{{item}}</span>
                </div>
              </div>
              <div v-else>
                <div v-for="(sitem,sindex) in item" :key="sindex" class="list-item">
                  <p>亮点</p>
                  <span>{{sitem}}</span>
                </div>
              </div>
            </div>
            <div v-if="she.cv_analysis.risks.length > 0">
              <div  v-for="(item,index) in she.cv_analysis.risks" :key="index">
                <div v-if="typeof(item) === 'string'">
                  <div class="list-item risks">
                    <p>风险</p>
                    <span>{{item}}</span>
                  </div>
                </div>
                <div v-else>
                  <div v-for="(sitem,sindex) in item" :key="sindex" class="list-item risks">
                    <p>风险</p>
                    <span>{{sitem}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="list-item risks">
                <p>风险</p>
                <span>暂未发现简历风险</span>
              </div>
            </div>
          </div>
        </div>
        <div class="content-item">
          <p class="content-title">我的简历分析评分</p>
          <span>{{me.cv_analysis.cv_score}}</span>
          <div class="point-list">
            <div v-if="me.cv_analysis.highlights.length > 0">
              <div v-for="(item,index) in me.cv_analysis.highlights" :key="index">
                <div v-if="typeof(item) === 'string'">
                  <div class="list-item">
                    <p>亮点</p>
                    <span>{{item}}</span>
                  </div>
                </div>
                <div v-else>
                  <div v-for="(sitem,sindex) in item" :key="sindex" class="list-item">
                    <p>亮点</p>
                    <span>{{sitem}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="list-item">
                <p>亮点</p>
                <span>暂未发现简历亮点</span>
              </div>
            </div>
            <div v-if="me.cv_analysis.risks.length > 0">
              <div  v-for="(item,index) in me.cv_analysis.risks" :key="index">
                <div v-if="typeof(item) === 'string'">
                  <div class="list-item risks">
                    <p>风险</p>
                    <span>{{item}}</span>
                  </div>
                </div>
                <div v-else>
                  <div v-for="(sitem,sindex) in item" :key="sindex" class="list-item risks">
                    <p>风险</p>
                    <span>{{sitem}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="list-item risks">
                <p>风险</p>
                <span>暂未发现简历风险</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
          <div class="footer-left">
            <p class="title">简历总结</p>
            <!-- <p v-if="skillToList.length > 0">你的简历中缺少<span class="differenceSkill"> {{skillToList.join("、")}}</span> 技能，建议参考大牛案例，补充相关的关键词。</p> -->
            <p class="left-info" v-if="me.cv_analysis.highlights.length > 0 && me.cv_analysis.risks.length <= 0">基于对简历整体内容分析，你的简历在同类竞争者中有优势，可以根据目标职位针对性优化简历。</p>
            <p class="left-info" v-if="me.cv_analysis.highlights.length > 0 && me.cv_analysis.risks.length > 0">基于对简历整体内容分析，你的简历在同类竞争者中有优势，但是在存在 {{me.cv_analysis.risks.length}}个 风险，在保证简历内容真实的前提下，扬长避短才是最佳策略。</p>
            <p class="left-info" v-if="me.cv_analysis.highlights.length <= 0 && me.cv_analysis.risks.length > 0">基于对简历整体内容分析，你的简历存在 {{me.cv_analysis.risks.length}}个 风险，在保证简历内容真实的前提下，扬长避短才是最佳策略。</p>
            <p class="left-info" v-if="me.cv_analysis.highlights.length <= 0 && me.cv_analysis.risks.length <= 0">暂未发现简历亮点，建议添加亮点，从而提升你的竞争力</p>
            
            
            <!-- <div class="light-point" v-if=""></div> -->
          
          </div>
          <div class="footer-right">
            <div class="right-title">
              <span class="iconfont icondaniumoban"></span>
              <p>【简历干货】如何制作高水平简历</p>
            </div>
            <p class="right-info">还想提升你的简历？快来看看简历干货</p>
            <div class="right-button" @click="goBBs">
              <p>立即查看</p>
              <span class="iconfont iconyou1"></span>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "comparison-skill",
    props: {
      me: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      she: {
        type: Object,
        default: ()=>{
          return {}
        }
      }
    },
    data(){
      return {
      }
    },
    mounted(){
      setTimeout(()=>{

      },1000)
    },
    methods:{
      goBBs(){
        // let url = process.env.NODE_ENV === 'production' ? 'https://www.wondercv.com/blog' : 'https://www.wondercv.cn/blog'
        window.open('https://www.wondercv.com/blog/SCqSLz5h.html')
      }
    }
  }
</script>

<style scoped lang="scss">
.comparison-skill-page{
  margin-bottom: 50px;
  .skill-name{
    font-size: 32px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 45px;
    margin-bottom: 34px;
  }
  .skill-content{
    width: 1200px;
    height: 332px;
    border-radius: 12px;
    padding: 32px;
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;
    .content-item{
      width: 552px;
      height: 300px;
      background: #252830;
      border-radius: 8px;
      padding: 24px;
      box-sizing: border-box;
      color: #fff;
      padding-bottom: 11px;
      .content-title{
        color: #CFCFCF;
        font-size: 14px;
      }
      span{
        font-size: 36px;
        font-weight: 500;
        margin-top: 5px;
        display: block;
        margin-bottom: 17px;
      }
    }
  }
  .skill-content::-webkit-scrollbar{
    display: none;
  }
}
.list-item{
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 26px;
  p{
    width: 52px;
    height: 26px;
    background: #4183FF;
    border-radius: 4px;
    text-align: center;
    line-height: 26px;
    font-size: 14px;
    margin-right: 16px;
  }
  span{
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 24px !important;
    flex: 1;
    margin: 0 !important;
  }
}
.risks{
  p{
    background: linear-gradient(180deg, #A6ABB4 0%, #6D727D 100%);
  }
}

.point-list{
  height: 195px;
  box-sizing: border-box;
  overflow-y: scroll;
  padding-top: 25px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}
.point-list::-webkit-scrollbar{
  display: none;
}
.box-content{
  height: 528px;
  background-image: url("https://files.wondercv.com/PC/editor/planning/people/bgcard_skillsmin.png");
  box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
  background-size: 100% 100%;
}

.footer{
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
  margin-top: 28px;
  padding-left: 32px;
  .footer-left{
    width: 740px;
    height: 132px;
    padding: 22px 24px;
    background: #252830;
    border-radius: 8px;
    box-sizing: border-box;
    .title{
      font-size: 18px;
      margin-bottom: 14px;
    }
    .differenceSkill{
      color:#FF8569 ;
    }
    .left-info{
      line-height: 24px;
    }
  }
  .footer-right{
    width: 364px;
    height: 132px;
    background: #252830;
    border-radius: 12px;
    margin-left: 32px;
    padding: 21px 24px;
    box-sizing: border-box;
    .right-title{
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      p{
        margin-left: 9px;
        font-size: 16px;
      }
      .iconfont{
        font-size: 17px;
      }
    }
    .right-info{
      font-size: 12px;
      display: block;
      margin-left: 26px;
      margin-top: 8px;
    }
    .right-button{
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      width: 143px;
      height: 38px;
      background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
      border-radius: 20px;
      margin-top: 15px;
      margin-left: 27px;
      font-size: 14px;
      cursor: pointer;
      p{
        margin-right: 6px;
      }
      .iconfont{
        font-size: 17px;
      }
    }
  }
}
</style>
